var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"my-2",attrs:{"rotate":360,"size":100,"width":10,"value":_vm.value,"color":"primary"}},[_c('span',{staticClass:"font-weight-bold text-xl"},[_vm._v(_vm._s(_vm.value)+" / 100")])])
}
var staticRenderFns = []

export { render, staticRenderFns }